import React from 'react';

const Terms = () => {
    return (
        <div className="page-content page-top">
            <div className="container-medium">
                <div className="page-header">
                    <h1 className="page-title">Terms of Service</h1>
                    <p className="text-muted">Last Updated: February 2026</p>
                </div>
                <div className="content-card legal-content">
                    <section className="legal-section">
                        <h2>1. Acceptance of Terms</h2>
                        <p>By accessing and using our TikTok Shop management platform, you agree to be bound by these
                            Terms of Service and all applicable laws and regulations. If you do not agree with any of
                            these terms, you are prohibited from using our services.</p>
                    </section>

                    <section className="legal-section">
                        <h2>2. Service Description</h2>
                        <p>Our platform provides tools for TikTok Shop sellers to manage products, orders, inventory,
                            and analytics. We reserve the right to modify, suspend, or discontinue any part of our
                            services at any time with reasonable notice.</p>
                    </section>

                    <section className="legal-section">
                        <h2>3. User Responsibilities</h2>
                        <p>As a user, you agree to:</p>
                        <ul>
                            <li>Provide accurate and complete information</li>
                            <li>Maintain the security of your account credentials</li>
                            <li>Use the service in compliance with all applicable laws</li>
                            <li>Not attempt to interfere with or disrupt our services</li>
                            <li>Not use the service for any fraudulent or illegal purposes</li>
                        </ul>
                    </section>

                    <section className="legal-section">
                        <h2>4. API Usage and TikTok Shop Integration</h2>
                        <p>Our platform integrates with TikTok Shop APIs. You must comply with TikTok's terms of service
                            and API usage policies. We are not responsible for changes to TikTok's API or policies that
                            may affect our services.</p>
                    </section>

                    <section className="legal-section">
                        <h2>5. Pricing and Payment</h2>
                        <p>Subscription fees are billed in advance on a monthly or annual basis. You are responsible for
                            providing valid payment information. Refunds are provided according to our refund policy
                            available on request.</p>
                    </section>

                    <section className="legal-section">
                        <h2>6. Limitation of Liability</h2>
                        <p>We provide our services "as is" without warranties of any kind. We shall not be liable for
                            any indirect, incidental, special, consequential, or punitive damages resulting from your
                            use of our services.</p>
                    </section>

                    <section className="legal-section">
                        <h2>7. Termination</h2>
                        <p>We reserve the right to terminate or suspend your account at any time for violations of these
                            terms. You may cancel your subscription at any time through your account settings.</p>
                    </section>

                    <section className="legal-section">
                        <h2>8. Contact Information</h2>
                        <p>For questions about these Terms of Service, please contact us at{' '}
                            <a href="mailto:service@xndeals.online"
                               className="text-link">service@xndeals.online</a>
                        </p>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default Terms;
